<template>
  <div>
    <p class="text-default">
      Upgrade to enable custom domain features for your account.
    </p>
    <div class="flex items-center mt-4">
      <IfPlan disallow-if-not-hipaa>
        <a class="button save bg-gradient-primary rounded-lg border-0 p-3 text-base leading-4 font-medium"
          target="_blank" rel="noreferrer" :href="constants.CONTACT_SUPPORT">
          Contact Support
        </a>
      </IfPlan>
      <IfPlan disallow-if-hipaa>
        <a class="button save bg-gradient-primary rounded-lg border-0 p-3 text-base leading-4 font-medium"
          target="_blank" rel="noreferrer" :href="constants.DASHBOARD_PLANS_URL">
          View Plans and Upgrade
        </a>
      </IfPlan>
      <a class="text-subtle hover:text-default underline ml-4 flex items-center" target="_blank" rel="noreferrer"
        :href="constants.LEARN_MORE_URL">
        <span>Learn More</span>
        <Icon type="arrow-top-right-thick" class="h-4 w-4 ml-2 top-1" />
      </a>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/ui/Icon.vue';
import CustomDomainUtils from '@/components/settings/custom-domains/CustomDomainUtils';
import IfPlan from '@/components/util/IfPlan';

export default {
  name: 'CustomDomainStarters',
  components: {
    Icon,
    IfPlan,
  },
  mixins: [
    CustomDomainUtils,
  ],
};
</script>

<style scoped></style>
